import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { interval, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';

@Pipe({
  name: 'appElapsed',
  // We need impure pipe because AsyncPipe is impure too, and this will let us refresh the elapsed time
  // eslint-disable-next-line @angular-eslint/no-pipe-impure
  pure: false
})
export class ElapsedPipe extends AsyncPipe implements PipeTransform {
  private _timestamp: string | number;
  private _observable: Observable<string>;

  private static readonly INTERVAL = interval(1000);

  constructor(changeDetectorRef: ChangeDetectorRef,
              private _translateService: TranslateService) {
    super(changeDetectorRef);
  }

  transform(input: any): any {
    if (typeof input === 'string' || typeof input === 'number') {
      this._timestamp = input;

      if (!this._observable) {
        this._observable = this.getObservable();
      }

      return super.transform(this._observable);
    }

    return super.transform(null);
  }

  private getObservable(): Observable<string> {
    return ElapsedPipe.INTERVAL.pipe(
      startWith(''),
      map(() => {
        if (!this._timestamp) {
          return '';
        }

        const duration: moment.Duration = moment.duration(moment().diff(this._timestamp));

        if (duration.asHours() < 1 && duration.asMinutes() < 1) {
          return this._translateService.instant('elapsedPipe.lessThanAMinute');
        } else if (duration.asHours() < 1) {
          return Math.floor(duration.asMinutes()) + moment.utc(duration.asMilliseconds()).format('[m]');
        } else {
          return Math.floor(duration.asHours()) + moment.utc(duration.asMilliseconds()).format('[h] m[m]');
        }
      })
    );
  }
}
